import { PureComponent } from 'react';

import DropDownButton from './DropDownButton';

import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';

export default class AlignmentControls extends PureComponent {
  toggleFloat = floatStyle => () => {
    const { blockData, onUpdateBlockData } = this.props;
    const activeFloat = blockData && blockData.get('float');
    onUpdateBlockData({ float: floatStyle === activeFloat ? undefined : floatStyle });
  };

  render() {
    const { blockData } = this.props;
    const activeFloat = blockData && blockData.get('float');
    return (
      <DropDownButton icon="Float" menu ToolbarButtonProps={{ active: !!activeFloat }} tooltip="alignment">
        {Object.values(FLOATS).map(({ label, type }) => (
          <MenuItem key={label} onMouseDown={this.toggleFloat(type)} selected={activeFloat === type}>
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </DropDownButton>
    );
  }
}

const FLOATS = {
  left: {
    label: 'Left',
    type: 'left',
  },
  right: {
    label: 'Right',
    type: 'right',
  },
  clear: {
    label: 'No Float',
    type: undefined,
  },
};
